const task = {
  // 我的任务
  getMyTask: `/userApi/v1/Task/getMyTask`,
  // 领取任务
  drawTask: `/userApi/v1/Task/drawTask`,
  // 任务列表
  getTaskList: `/userApi/v1/Task/getTaskList`,
  // 根据id获取任务详情
  getTaskInfo: `/userApi/v1/Task/getTaskInfo`,
  // 任务信用分规则
  getTaskconfig: `/userApi/v1/Task/getTaskconfig`,
  // 任务规则
  taskRule: `/userApi/v2/Task/getTaskRule`,
  // 任务奖励
  getBonus: `/userApi/v1/Task/getBonus`,
  // 任务奖励二
  getBonus2: `/userApi/v1/Task/getBonus2`,
  // 获取任务完成详情-不领奖
  getTaskAndBonus: `/userApi/v1/Task/getTaskAndBonus`,
  // 任务搜索
  searchGame: `/userApi/v1/Task/searchGame`,
  // 游戏下任务列表
  getGameTask: `/userApi/v1/Task/getGameTask`,
  // 任务标签列表
  getTaskFilter: `/userApi/v1/Task/getTaskFilter`,
  // 任务列表-460新
  getTaskListV1: `/userApi/v1/Task/getTaskListV1`
};

export default task;
